module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5pO70"))).then(() => parcelRequire('hEqeo'));